import { render } from "./BasePagination.vue?vue&type=template&id=4d0cd1d4&ts=true"
import script from "./BasePagination.vue?vue&type=script&lang=ts"
export * from "./BasePagination.vue?vue&type=script&lang=ts"

import "./BasePagination.vue?vue&type=style&index=0&id=4d0cd1d4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__